import { Module } from "wrapper6";

/* global jQuery */

export default class ScrollToTop extends Module {

	ready() {
		var btn = jQuery('#scroll-to-top');

		if(jQuery('.course-nav').length){
			btn.addClass('has-course-nav');
		}

		jQuery(window).scroll(function() {
			if (jQuery(window).scrollTop() > 300) {
				btn.addClass('show');
			} else {
				btn.removeClass('show');
			}
		});

		btn.on('click', function(e) {
			e.preventDefault();
			jQuery('html, body').animate({scrollTop:0}, '300');
		});
	}
}